import { ERequestAuthenticationActionType } from './types';
import { TAuthenticationModalType } from '../../types/authenticationModal';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const requestAuthenticationModal = actionGenerator<
  ERequestAuthenticationActionType.Modal,
  TAuthenticationModalType
>(ERequestAuthenticationActionType.Modal);
